/** Где была создана новая подборка */
export var ECreateFolderSource = /*#__PURE__*/function (ECreateFolderSource) {
  ECreateFolderSource["List"] = "list";
  ECreateFolderSource["Notification"] = "notification";
  return ECreateFolderSource;
}({});